import Layout from "@components/layout";
import {
  DynamicPage,
  MenuPage,
  OstatkiPage,
  ReportABCPage,
  ReportByDayPage,
  ReportRestaurantsPage,
  RevenuePage,
  StopPositionsPage,
  TopPositionsPage,
} from "@pages";
import { RouteConfig } from "@types";

export const rkeeper = (): RouteConfig => {
  return {
    path: "rkeeper",
    element: <Layout />,
    redirect: "revenue",
    children: [
      { path: "revenue", element: <RevenuePage />, navKey: "rkeeper.revenue" },
      { path: "dynamic", element: <DynamicPage />, navKey: "rkeeper.dynamic" },
      { path: "menu", element: <MenuPage />, navKey: "rkeeper.menu" },
      {
        path: "ostatki",
        element: <OstatkiPage />,
        navKey: "rkeeper.store.ostatki",
      },
      {
        path: "toppositions",
        element: <TopPositionsPage />,
        navKey: "rkeeper.toppositions",
      },
      {
        path: "stoppositions",
        element: <StopPositionsPage />,
        navKey: "rkeeper.stoppositions",
      },
      {
        path: "reports_days",
        element: <ReportByDayPage />,
        navKey: "rkeeper.report.days",
      },
      {
        path: "reports_like4like",
        element: <ReportRestaurantsPage />,
        navKey: "rkeeper.report.like4like",
      },
      {
        path: "reports_abc",
        element: <ReportABCPage />,
        navKey: "rkeeper.report.abc",
      },
    ],
  };
};

export default rkeeper;
